/** follows enum ClientDataType in IteraQLApiSpec.yml in main repo */
export enum EventTypes {
  Bounce = 'Bounce',
  Click = 'Click',
  User = 'User',
  Open = 'Open',
  Complaint = 'Complaint',
  Send = 'Send',
  SendSkip = 'SendSkip',
  Purchase = 'Purchase',
  CustomEvent = 'CustomEvent',
  HostedUnsubscribeClick = 'HostedUnsubscribeClick',
  InAppClick = 'InAppClick',
  InAppClose = 'InAppClose',
  InAppDelete = 'InAppDelete',
  InAppDelivery = 'InAppDelivery',
  InAppOpen = 'InAppOpen',
  InAppRecall = 'InAppRecall',
  InAppSend = 'InAppSend',
  InAppSendSkip = 'InAppSendSkip',
  InboxMessageImpression = 'InboxMessageImpression',
  InboxSession = 'InboxSession',
  PushBounce = 'PushBounce',
  PushOpen = 'PushOpen',
  PushSend = 'PushSend',
  PushSendSkip = 'PushSendSkip',
  PushUninstall = 'PushUninstall',
  SMSBounce = 'SMSBounce',
  SMSClick = 'SMSClick',
  SMSReceived = 'SMSReceived',
  SMSSend = 'SMSSend',
  SMSSendSkip = 'SMSSendSkip',
  SMSUsageInfo = 'SMSUsageInfo',
  Subscribe = 'Subscribe',
  UnSubscribe = 'UnSubscribe',
  WebPushClick = 'WebPushClick',
  WebPushSend = 'WebPushSend',
  WebPushSendSkip = 'WebPushSendSkip',
}

export enum SystemEventType {
  AddedItemToCart = 'AddedItemToCart',
  EmailClicked = 'EmailClicked',
  InAppClicked = 'InAppClicked',
  InAppClosed = 'InAppClosed',
  InAppDeleted = 'InAppDeleted',
  InAppDelivered = 'InAppDelivered',
  InAppOpened = 'InAppOpened',
  OpenedEmail = 'OpenedEmail',
  OpenedPush = 'OpenedPush',
  Purchased = 'Purchased',
  ReceivedAnSMS = 'ReceivedAnSMS',
  Subscribed = 'Subscribed',
  Unknown = 'Unknown',
  Unsubscribed = 'Unsubscribed',
}
